import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainBindCardForWeChat(params) {
  return maintainRequest({
    url: `/user/maintenanceMan/card/bindCardForWeChat`,
    method: "post",
    params: params,
  });
}
